import React from 'react'
import {
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogContentText,
  DialogActions
} from '@material-ui/core'

function ImportDialog(props) {
  const [open, setOpen] = React.useState(true)

  return (
    <Dialog
      open={ open }
      onClose={ () => setOpen(false) && props.onClose() }
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
    >
      <DialogTitle id="alert-dialog-title">{ props.title }</DialogTitle>
      <DialogContent>
        <DialogContentText id="alert-dialog-description">
          { props.children }
        </DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button onClick={ () => setOpen(false) } color="primary">
          Fechar
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default ImportDialog
